<template>
  <div id="college-search" >
    <!-- List of colleges -->
    <div id="college-list">
      <h4 @click="showColleges = !showColleges">
        {{selectedCollegeInd == null ? 'Select College' : 'Change College'}}
        <i class="fa fa-caret-down" aria-hidden="true"></i>
      </h4>
        <div id="list-wrapper" :class="{show: showColleges}">
          <div id="list">
            <a v-for="(college, i) in colleges" class="ds-main ds-color-hover" :class="{active: selectedCollegeInd == i}" @click="selectCollege(i)">
              {{college.key}}
            </a>
          </div>
        </div>
    </div>

    <!-- List of associated majors -->
    <div v-if="selectedCollegeInd != null" id="college-majors" ref='collegePlaceholder'>
      <h1>{{selectedCollege.key}}</h1>
      <h4>{{selectedCollege.values.length}} Program{{selectedCollege.values.length > 1 ? 's' : ''}}</h4>
      <major-list :majors="filteredColleges" :collegeSelectorShown="true"></major-list>
    </div>
  </div>
</template>

<script>
  import MajorList from '../components/major_list'

  export default {
    name: 'CollegeSearch',

    data() {
      return {
        showColleges: false,
        colleges: [],
        selectedCollegeInd: null,
        majors: [],
        // collegeSelectorHidden: false,
        previousMajorListY: 0
      }
    },

    computed: {
      selectedCollege() {
        return this.colleges[this.selectedCollegeInd]
      },

      filteredColleges() {
        return this.colleges[this.selectedCollegeInd].values
      }
    },

    created() {
      window.addEventListener('scroll', this.setCollegeSelectorHidden)
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.setCollegeSelectorHidden)
    },

    mounted() {
      this.$store.commit('setCurrentView', 'collegeView')
      this.getColleges()
      // show the first college by default
      this.selectedCollegeInd = this.colleges.length !== 0 ? 0 : null
    },

    methods: {
      getColleges() {
        this.colleges = this.$store.getters.nestedCurrentColleges
      },

      selectCollege(i) {
        this.selectedCollegeInd = i
        this.showColleges = false
      },

      setCollegeSelectorHidden() {
        const y = this.$refs.collegePlaceholder.getBoundingClientRect().y
        const previousMajorListY = this.previousMajorListY

        if (previousMajorListY > y + 2 || previousMajorListY < y - 2) {
          // this.collegeSelectorHidden = true
          this.showColleges = false
        }

        // if (previousMajorListY < y - 2) {
        //   this.collegeSelectorHidden = false
        // }
        this.previousMajorListY = this.$refs.collegePlaceholder.getBoundingClientRect().y
      }
    },

    components: {
      'major-list': MajorList
    }
  }
</script>



// WEBPACK FOOTER //
// CollegeSearch.vue?486a0840